import { styled, keyframes } from 'styled-components';

const fadeIn = () => keyframes`
  from {
    opacity: 0;
    transform: translateY(23px) scale(0);
  }

  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
`;

const fadeOut = () => keyframes`
  from {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
  to {
    opacity: 0;
    transform: translateY(23px) scale(0);

  }
`;

export const Arrow = styled.div<{ $visible: boolean }>`
  position: fixed;
  bottom: 94px;
  right: 48px;
  width: 48px;
  height: 48px;
  cursor: pointer;
  z-index: 4;
  background: ${({ theme }) => theme.colors.black_1};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: ${({ $visible }) => ($visible ? fadeIn : fadeOut)} 0.16s ease;
  transform-origin: 50%;
  ${({ theme }) => theme.shadows.shadowTuna};
`;
